import { render } from "./new-page.vue?vue&type=template&id=7378be4e&scoped=true"
import script from "./new-page.vue?vue&type=script&lang=js"
export * from "./new-page.vue?vue&type=script&lang=js"

import "./new-page.vue?vue&type=style&index=0&id=7378be4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7378be4e"]])

export default __exports__